import { useEffect } from 'react';

export default function useBodyOverflowHidden(hidden: boolean): void {
  useEffect(() => {
    if (hidden) {
      const scrollbarWidth = Math.abs(window.innerWidth - document.documentElement.clientWidth);
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }

    return () => {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    };
  });
}
